import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, setApiKeyToObject, toPathString } from '../common.mjs';
import { BASE_PATH, BaseAPI } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const FilePublicApiControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary 파일 제한 타입 조회
     * @param {FilePublicApiControllerApiGetFileSourceTypeRestrictionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFileSourceTypeRestrictions: ({ sourceType }, options = {}) => {
      assertParamExists("getFileSourceTypeRestrictions", "sourceType", sourceType);
      const localVarPath = "/api-public/v2/recruiting/files/restrictions/source-types/{sourceType}".replace("{".concat("sourceType", "}"), encodeURIComponent(String(sourceType)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setApiKeyToObject(localVarHeaderParameter, "WS_AID", configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return __spreadProps(__spreadValues({}, localVarRequestOptions), {
        identifier: "getFileSourceTypeRestrictions",
        url: toPathString(localVarUrlObj)
      });
    },
    /**
     * 
     * @summary 임시 파일 업로드
     * @param {FilePublicApiControllerApiUploadTemporaryFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadTemporaryFile: ({ customerIdHash, sourceType, multipartFile }, options = {}) => {
      assertParamExists("uploadTemporaryFile", "customerIdHash", customerIdHash);
      assertParamExists("uploadTemporaryFile", "sourceType", sourceType);
      assertParamExists("uploadTemporaryFile", "multipartFile", multipartFile);
      const localVarPath = "/api-public/v2/recruiting/customerId/{customerIdHash}/files/temporary/upload".replace("{".concat("customerIdHash", "}"), encodeURIComponent(String(customerIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setApiKeyToObject(localVarHeaderParameter, "WS_AID", configuration);
      if (sourceType !== void 0) {
        localVarQueryParameter["sourceType"] = sourceType;
      }
      if (multipartFile !== void 0) {
        localVarFormParams.append("multipartFile", multipartFile);
      }
      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = localVarFormParams;
      return __spreadProps(__spreadValues({}, localVarRequestOptions), {
        identifier: "uploadTemporaryFile",
        url: toPathString(localVarUrlObj)
      });
    }
  };
};
const FilePublicApiControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = FilePublicApiControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary 파일 제한 타입 조회
     * @param {FilePublicApiControllerApiGetFileSourceTypeRestrictionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFileSourceTypeRestrictions(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getFileSourceTypeRestrictions(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @summary 임시 파일 업로드
     * @param {FilePublicApiControllerApiUploadTemporaryFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadTemporaryFile(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.uploadTemporaryFile(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const FilePublicApiControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = FilePublicApiControllerApiFp(configuration);
  return {
    /**
     * 
     * @summary 파일 제한 타입 조회
     * @param {FilePublicApiControllerApiGetFileSourceTypeRestrictionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFileSourceTypeRestrictions(requestParameters, options) {
      return localVarFp.getFileSourceTypeRestrictions(requestParameters, options)(axios, basePath);
    },
    /**
     * 
     * @summary 임시 파일 업로드
     * @param {FilePublicApiControllerApiUploadTemporaryFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadTemporaryFile(requestParameters, options) {
      return localVarFp.uploadTemporaryFile(requestParameters, options)(axios, basePath);
    }
  };
};
class FilePublicApiControllerApi extends BaseAPI {
  /**
   * 
   * @summary 파일 제한 타입 조회
   * @param {FilePublicApiControllerApiGetFileSourceTypeRestrictionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FilePublicApiControllerApi
   */
  getFileSourceTypeRestrictions(requestParameters, options) {
    return FilePublicApiControllerApiFp(this.configuration).getFileSourceTypeRestrictions(requestParameters, options)(this.axios, this.basePath);
  }
  /**
   * 
   * @summary 임시 파일 업로드
   * @param {FilePublicApiControllerApiUploadTemporaryFileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FilePublicApiControllerApi
   */
  uploadTemporaryFile(requestParameters, options) {
    return FilePublicApiControllerApiFp(this.configuration).uploadTemporaryFile(requestParameters, options)(this.axios, this.basePath);
  }
}
const getFileSourceTypeRestrictionsRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: FilePublicApiControllerApiAxiosParamCreator().getFileSourceTypeRestrictions,
  requestFn: FilePublicApiControllerApiFp().getFileSourceTypeRestrictions
});
const uploadTemporaryFileRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: FilePublicApiControllerApiAxiosParamCreator().uploadTemporaryFile,
  requestFn: FilePublicApiControllerApiFp().uploadTemporaryFile
});

export { FilePublicApiControllerApi, FilePublicApiControllerApiAxiosParamCreator, FilePublicApiControllerApiFactory, FilePublicApiControllerApiFp, getFileSourceTypeRestrictionsRemote, uploadTemporaryFileRemote };
//# sourceMappingURL=file-public-api-controller-api.mjs.map
